import React from 'react'
import FeatureTable from './components/FeatureTable'
import { Cell, CheckCell, ValueCell } from './components/ValueCell'
import campaignIcon from './images/campaign.png'

const Platform = () => {
  return (
    <FeatureTable title="评价&问卷" icon={campaignIcon}>
      <>
        <tr>
          <Cell>创建量</Cell>
          <ValueCell>3 份</ValueCell>
          <ValueCell>不限量</ValueCell>
          <ValueCell>不限量</ValueCell>
          <ValueCell>不限量</ValueCell>
        </tr>
        <tr>
          <Cell>总数据量</Cell>
          <ValueCell>3000条/年</ValueCell>
          <ValueCell>10万条/年</ValueCell>
          <ValueCell>50万条/年</ValueCell>
          <ValueCell>100万条/年</ValueCell>
        </tr>
        {[
          '一页多题',
          '引导(CTA) 字段',
          '贴边按钮/弹框展现',
          '自定义主题样式',
          '问卷场景模板',
          '字段显隐/跳转规则',
          '基础投放规则',
          '免打扰机制',
          '用户身份传递',
          '基础数据报表',
          '多语言问卷',
        ].map((item, index) => (
          <tr key={index}>
            <Cell>{item}</Cell>
            <CheckCell />
            <CheckCell />
            <CheckCell />
            <CheckCell />
          </tr>
        ))}
        {['在线截图', '指定投放时间', '精准用户投放', '事件触发投放'].map((item, index) => (
          <tr key={index}>
            <Cell>{item}</Cell>
            <ValueCell />
            <CheckCell />
            <CheckCell />
            <CheckCell />
          </tr>
        ))}
      </>
    </FeatureTable>
  )
}

export default Platform
